import type { QuerySlice } from '../../store/appStore/queryStore/querySlice'
import { RenderPipeline } from '../RenderPipeline'
import { QueryStoreOutputParts } from './QueryStore.parts'

/** Pipeline input — the Zustand query slice, nested under `store`. */
export interface QueryStoreInput {
  store: QuerySlice
}

/** Pipeline output slice — passthrough of the nested query slice. */
export interface QueryStoreOutput {
  store: QuerySlice
}

const queryStoreSetup = () =>
  RenderPipeline.createFeatureSetup<QueryStoreInput, QueryStoreOutput>(
    QueryStoreOutputParts.setStore(),
  )

export const QueryStore = {
  setup: queryStoreSetup,
}
